export interface IMaltiaResponse<T = any> {
  data?: T;
  error: boolean;
  message: string;
  code: number;
}

export class MaltiaResponse<T = any> {
  data?: T;
  error: boolean;
  message: string;
  code: number;

  constructor(data: IMaltiaResponse) {
    this.data = data.data;
    this.error = data.error;
    this.message = data.message;
    this.code = data.code;
  }
}
